(() => {
  const fileKey = src => {
    if (!src) return '';
    try {
      return decodeURIComponent(new URL(src, window.location.origin).pathname)
        .split('/')
        .pop()
        .toLowerCase();
    } catch (error) {
      return src.split('?')[0].split('/').pop().toLowerCase();
    }
  };

  const syncSelectedColorMedia = (attempt = 0) => {
    const currentSwatchImage = document.querySelector(
      '.bip-color-selector__swatch.is-current img'
    );
    const targetKey = fileKey(
      currentSwatchImage?.currentSrc || currentSwatchImage?.src
    );

    if (!targetKey) return;

    const gallery = document.querySelector(
      'swiper-product-gallery[handle="product-gallery"]'
    );
    const slides = gallery
      ? Array.from(gallery.querySelectorAll('.swiper-slide'))
      : [];
    const targetSlide = slides.find(slide => {
      const image = slide.querySelector('img');
      return fileKey(image?.currentSrc || image?.src) === targetKey;
    });

    if (targetSlide) {
      const targetIndex = Number(targetSlide.dataset.index);
      targetSlide.setAttribute('data-selected', '');

      if (
        gallery.instance &&
        typeof gallery.instance.slideTo === 'function' &&
        Number.isFinite(targetIndex)
      ) {
        gallery.instance.slideTo(targetIndex, 0);
      }

      const thumbs = document.querySelector(
        'swiper-product-thumbs[handle="product-thumbs"]'
      );
      if (
        thumbs?.instance &&
        typeof thumbs.instance.slideTo === 'function' &&
        Number.isFinite(targetIndex)
      ) {
        thumbs.instance.slideTo(targetIndex, 0);
      }
    }

    const mediaGrid = document.querySelector('.main-product__media--grid');
    if (mediaGrid) {
      const targetGridItem = Array.from(mediaGrid.children).find(item => {
        const image = item.querySelector('img');
        return fileKey(image?.currentSrc || image?.src) === targetKey;
      });
      if (
        targetGridItem &&
        targetGridItem !== mediaGrid.firstElementChild
      ) {
        mediaGrid.insertBefore(targetGridItem, mediaGrid.firstElementChild);
      }
    }

    if ((!gallery?.instance || !targetSlide) && attempt < 20) {
      window.setTimeout(() => syncSelectedColorMedia(attempt + 1), 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => syncSelectedColorMedia(),
      { once: true }
    );
  } else {
    syncSelectedColorMedia();
  }

  document.addEventListener('shopify:section:load', () =>
    syncSelectedColorMedia()
  );
})();
